import React, {Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { dateFormation, isEmpty, toastr } from '../../common/cores';
import {SlideDown} from '../../utils';
import { DoQuestion, GetQuestionList } from '../../common/actions/moreAction';
import Pagenation from '../common/Pagenation';
import BackButton from './BackButton';
import NavLink from 'react-router-dom/NavLink';
const InquiriesContent = (props) => {

    const [inputs, setInputs] = useState({
        name: '',
        nickname: ''
      });
      const [showHis, setShowHis] = useState(false);

      const [ showContent, setShowContent ] = useState(false);
      const [ showInput, setShowInput ] = useState(false);
      const [ selected, setSelected ] = useState({});
      const { questions, page , setVal, type } = props;
    
      const { title, question } = inputs; // 비구조화 할당을 통해 값 추출
    
      const onChange = (e) => {
        const { value, name } = e.target; // 우선 e.target 에서 name 과 value 를 추출
        console.log(e.target)
        setInputs({
          ...inputs, // 기존의 input 객체를 복사한 뒤
          [name]: value // name 키를 가진 값을 value 로 설정
        });
      };
    
      const onReset = () => {
        setInputs({
          title: '',
          question: '',
        })
      };
    const DoQuestion = () => {;
        console.log(title, question);
        if (isEmpty(title))
          return toastr.warning(`${isEmpty(window.lang["제목을 입력해주세요."]) ? "제목을 입력해주세요." : window.lang["제목을 입력해주세요."]}`);
        if (isEmpty(question))
          return toastr.warning(`${isEmpty(window.lang["내용을 입력해주세요."]) ? "내용을 입력해주세요." : window.lang["내용을 입력해주세요."]}`);
        if(!props.isAuthenticated)
            return toastr.warning(`${isEmpty(window.lang["로그인하시고 이용해주세요."]) ? "로그인하시고 이용해주세요." : window.lang["로그인하시고 이용해주세요."]}`);
        props.DoQuestion({ title, question })
            .then(()=>{ 
                setShowInput(false); 
                setSelected({});
                GetQuestionList(1);
                setShowHis(!showHis);
            });
      }
    
      const GetQuestionList = page => {
        props.GetQuestionList({
          page: page,
          curPage: props.page.perPage
        })
      }
    
      const onShowContent = (questionData) => {
        setSelected(questionData);
        setShowInput(false); 
        setShowHis(!showHis);
      }

      const cancelQuestion = () => {
        setShowInput(false); 
        setShowContent(false);
        setSelected({})
        setShowHis(!showHis);
      }

      const showQuestion = () => {
        setShowInput(true); 
        setShowContent(false);
        setSelected({})
        setShowHis(!showHis);
      }

      useEffect(()=>{
    
        GetQuestionList(1);
      },[ props.page.perPage ])

      const showHisotry = () => {
          setShowHis(!showHis);
          // console.log("--------------------slide")
          // SlideDown();
      }

    return (
            
      <Fragment>
          <div className="con_box10">        
               {!isEmpty(questions) &&
                      questions.map((item, index) => {
                          return (
                              <Fragment key={index} >
                                  <div className="qna_list" onClick={showHisotry}>
                                      <div className="qna_text">{!isEmpty(item.title) && item.title}</div>
                                      <div className="qna_time">{!isEmpty(item.created_date) && dateFormation(item.created_date)}</div>
                                  </div>
                                  <div className="qna_view" style={{ display: showHis ? "block" : "" }}>				
                                      <div className="qna_text2">{isEmpty(item.answer) == false ? item.answer : isEmpty(window.lang["답변이 없습니다."]) ? "답변이 없습니다." : window.lang["답변이 없습니다."] }</div>
                                  </div>
                              </Fragment>
                          )
                      })
              }    
              
          </div>
          <Pagenation page={page.curPage} 
              totalPage={page.totalPage} 
              getPage={GetQuestionList}
              perPage={10}/>
        </Fragment>
         
   )
}

const mapStateToProps = state => ({
  questions: state.more.custommercenter.data,
  isAuthenticated: state.user.isAuthenticated,
  curPage: state.page.curPage,
  totalPage: state.page.totalPage,
  page: state.page,
  user: state.user
});

export default connect(mapStateToProps, {
  DoQuestion, GetQuestionList
})(InquiriesContent);


// WEBPACK FOOTER //
// ./src/components/account/InquirieContent1.js